import { QueryHookOptions } from '@apollo/client';
import React from 'react';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

// We pay an n+1 on this. It makes life easier
export const GET_JOB_STATUS_QUERY = gql`
  query GetJobStatus($cloudId: String!) {
    getJob(cloudId: $cloudId) {
      cloudId
      jobStatus {
        status
        orderIndex
        cloudId
      }
      WfDeletedOnUTC
    }
  }
` as import('../../__generated__/ts-gql/GetJobStatus').type;

export type GetJobStatusQueryVariables = OperationVariables<
  typeof GET_JOB_STATUS_QUERY
>;
export type GetJobStatusQueryResult = OperationData<
  typeof GET_JOB_STATUS_QUERY
>;
export type GetJobStatusType = GetJobStatusQueryResult['getJob'];

export type GetJobStatusResult = NonNullable<ReturnType<typeof processData>>;

// type pickedJob = Pick<Job, 'cloudId' | 'WfDeletedOnUTC' | 'jobStatus'>;

// type omittedJob = Omit<pickedJob, 'WfDeletedOnUTC' | 'jobStatus'>;

// export interface GetJobStatusResult extends omittedJob {
//   jobStatus: {
//     cloudId: string;
//     status?: JobStatus;
//     orderIndex: number;
//   };
//   WfDeletedOnUTC: Date | undefined | null;
// }

export const useGetJobStatus = (
  options: QueryHookOptions<GetJobStatusQueryResult, GetJobStatusQueryVariables>
) => {
  const variables = options.variables as GetJobStatusQueryVariables;

  const res = useQuery(GET_JOB_STATUS_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => {
    return {
      ...res,
      data: processData(res.data),
    };
  }, [res]);
};

export function processData(data: GetJobStatusQueryResult | undefined) {
  const job = data?.getJob;
  const result = job && {
    ...job,
    jobStatus: {
      cloudId: job.jobStatus?.cloudId || '', // this cannot ever be null
      status: job.jobStatus?.status,
      orderIndex:
        job.jobStatus && job.jobStatus.orderIndex
          ? job.jobStatus.orderIndex
          : 0,
    },
    WfDeletedOnUTC: job.WfDeletedOnUTC && new Date(job.WfDeletedOnUTC),
  };
  return result;
}
